import * as React from "react";

export const IconCheck = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.65833 8.81667L1.18333 5.34167L0 6.51667L4.65833 11.175L14.6583 1.175L13.4833 0L4.65833 8.81667Z" fill="currentColor" />
  </svg>
);
